import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef,
} from 'primeng/dynamicdialog';

@Component({
  selector: 'lib-delete-user-dialog',
  imports: [CommonModule, ButtonModule, DialogModule],
  templateUrl: './delete-user-dialog.component.html',
  styleUrl: './delete-user-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [DialogService],
})
export class DeleteUserDialogComponent {
  private ref = inject(DynamicDialogRef);
  private dialogConfig = inject(DynamicDialogConfig);

  userName = this.dialogConfig.data?.user;

  cancel() {
    this.ref.close(false);
  }

  delete() {
    this.ref.close(true);
  }
}
